import React, { useEffect } from 'react';
import './contact.css';
import sellbuddy from '../../assets/sellbuddy.png';
import ktplogo from '../../assets/ktplogo.png';

const Timeline = () => {
    const experiences = [
        {
            date: "June 2024 - August 2024",
            title: "Front-End Dev",
            company: "KTP App Commitee",
            location: "Boston, Massachusetts",
            details: ["Front End"],
            icon: ktplogo,
            position: 'left'
        },
        {
            date: "June 2024 - August 2024",
            title: "Data Science Intern",
            company: "Sell Buddy",
            location: "Denver, Colorado",
            details: ["Marketing and Operations Data Science Intern"],
            icon: sellbuddy,
            position: 'right'
        },
        
        // Add more experiences 
    ];


    useEffect(() => {
        const observer = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    entry.target.classList.add('visible');
                } else {
                    entry.target.classList.remove('visible');
                }
            });
        }, { threshold: 0.5 });

        const elements = document.querySelectorAll('.timelineContent');
        elements.forEach(el => observer.observe(el));

        return () => { elements.forEach(el => observer.unobserve(el)); }
    }, []);

    return (
        <section id="experience">
            <h2 className="experienceTitle">Experience</h2>
            <div className="timeline">
                {experiences.map((exp, index) => (
                    <div key={index} className={`timelineItem ${exp.position}`}>
                        <div className="timelineContent">
                            <h3>{exp.title}</h3>
                            <h4>{exp.company}</h4>
                            <p>{exp.date}</p>
                            <p>{exp.location}</p>
                            <ul>
                                {exp.details.map((detail, idx) => <li key={idx}>{detail}</li>)}
                            </ul>
                        </div>
                        <div className="timelineIcon">
                            <img src={exp.icon} alt="Event" />
                        </div>
                    </div>
                ))}
            </div>
        </section>
    );
}

export default Timeline;
